import React, { Component } from 'react';

import { Form, TreeSelect } from 'antd';

import service from '../../services';
const FormItem = Form.Item;

class Category extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: undefined,
            data: [],
            maps: {},
            keys: ['1']
        };
    }

    componentDidMount() {
        this.querySearch();
    }

    querySearch() {
        return service.supv.category.querySearch({
            userType: this.props.userType?  this.props.userType : 0
        })
        .then((data) => {
            this.setState({
                value: this.props.value ? [this.props.value + ''] : undefined
            });
            this.setState(data);
            this.setState({
                keys: [data.data[0].key+'']
            });
        });
        
    }

    componentWillReceiveProps(nextProps) {

        if(nextProps.hasOwnProperty('value')) {
            this.setState({
                value: nextProps.value ? [nextProps.value + ''] : undefined,
            });
        }

    }

    handleChange(value) {
        this.setState({
            value: value
        });

        if(this.props.handleChange) {
            this.props.handleChange({
                categoryId: value,
                categoryName: this.state.maps[value]
            });
        }
    }

    render() {
        const {label,style , name, notAllowClear, getFieldDecorator,actionDisable} = this.props;
        const { data, value } = this.state;
        return (
            <FormItem label={label || "任务分类"}>
                {
                    getFieldDecorator ? (
                        getFieldDecorator(name, {
                            initialValue: value,
                            rules: [{
                                required: true,
                                message: '请选择任务分类',
                            }],
                        })(
                            <TreeSelect
                            allowClear={notAllowClear === true ? false : true}
                            value={value}
                            treeDefaultExpandAll={false}
                            disabled={actionDisable}
                            treeData={data}
                            dropdownClassName="org-tree-select"
                            placeholder='请选择...'
                            treeDefaultExpandedKeys={this.state.keys}
                            style= {style || {width: 240}}
                            onChange={(value) => {
                                if(value) {
                                    this.handleChange(value);
                                } else {
                                    this.handleChange(value);
                                }
                            }}
                            ></TreeSelect>
                        )
                    ) : (
                        <TreeSelect
                        treeDefaultExpandAll={false}
                        allowClear={notAllowClear === true ? false : true}
                        value={value}
                        disabled={actionDisable}
                        treeData={data}
                        dropdownClassName="org-tree-select"
                        placeholder='请选择...'
                        treeDefaultExpandedKeys={this.state.keys}
                        style= {style || {width: 240}}
                        onChange={(value) => {
                            if(value) {
                                this.handleChange(value);
                            } else {
                                this.handleChange(value);
                            }
                        }}
                        ></TreeSelect>
                    )
                }

            </FormItem>
        );
    }
}

export default Category;